import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import { application } from '../application'

import CheckProducts from '../front_stage/check_products_controller'
import FooterScroll from '../front_stage/footer_scroll_controller'
import SetConversionCookies from '../front_stage/set_conversion_cookies_controller'
import StructuredDataFaq from '../front_stage/structured_data_faq_controller'

application.register('check-products', CheckProducts)
application.register('footer-scroll', FooterScroll)
application.register('set-conversion-cookies', SetConversionCookies)
application.register('structured-data-faq', StructuredDataFaq)

const context = require.context('.', true, /_controller\.js$/)
application.load(definitionsFromContext(context))
